import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faChevronUp,
    faDroplet,
    faThermometer,
    faThermometerHalf, 
    faSun,
    faTriangleExclamation
} from "@fortawesome/free-solid-svg-icons";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import api from "../../apis/EdisonApi";
import { toast } from "react-toastify";

const Husqvarna = () => {
    const [status, setStatus] = useState('NA');

    useEffect(() => {
        const controller = new AbortController();
        getHusqvarnaData();
        
        return () => {
            controller.abort();
        };
    }, []);

    const getHusqvarnaData = async () => {

        try {
            const resp = await api.get('/husqvarna/status');
            setStatus(resp.data);
        } catch {
            toast.error('API error fetching data, please retry.');
        }
    };

    const renderSoilHumidity = () => {
        if (status === 'NA') {
            return <div className="count">NA</div>;
        }

        return ( 
            <div className="count">
                {status.sensorData?.attributes?.soilHumidity?.value}%
            </div>
        );
    };

    const renderSoilTemperature = () => {
        if (status === 'NA') {
            return <div className="count">NA</div>;
        }

        return (
            <div className="count">
                {status.sensorData?.attributes?.soilTemperature?.value}°C
            </div>
        );
    };

    const renderAmbientTemperature = () => {
        if (status === 'NA') {
            return <div className="count">NA</div>;
        }

        return (
            <div className="count">
                {status.sensorData?.attributes?.ambientTemperature?.value}°C
            </div>
        );
    };

    const renderLightIntensity = () => {
        if (status === 'NA') {
            return <div className="count">NA</div>;
        }

        return (
            <div className="count">
                {status.sensorData?.attributes?.lightIntensity?.value}%
            </div>
        );
    };

    const renderWaterValve = () => {
        if (status === 'NA') {
            return <div className="count">NA</div>;
        }

        return (
            <div className="count">
                {status.valveData?.attributes?.activity?.value}
            </div>
        );
    };

    const renderWaterValveStatus = () => {
        if (status === 'NA') {
            return <div className="count">NA</div>;
        }

        return (
            <div className="count">
                {status.valveData?.attributes?.state?.value}
            </div>
        );
    };

    const renderDetails = () => {
        if (status === 'NA') {
            return (
                <div className="x_content">
                    <div>Device ID: husqvarna1</div>

                    <div>soilHumidity value: NA</div>
                    <div>soilHumidity timestamp: NA</div>
                    
                    <div>soilTemperature value: NA</div>
                    <div>soilTemperature timestamp: NA</div>
                    
                    <div>ambientTemperature value: NA</div>
                    <div>ambientTemperature timestamp: NA</div>
                    
                    <div>lightIntensity value: NA</div>
                    <div>lightIntensity timestamp: NA</div>

                    <div>batteryLevel value: NA</div>
                    <div>batteryLevel timestamp: NA</div>

                    <div>batteryState value: NA</div>
                    <div>batteryState timestamp: NA</div>

                    <div>rfLinkLevel value: NA</div>
                    <div>rfLinkLevel timestamp: NA</div>

                    <div>waterValve value: NA</div>
                    <div>waerValve status: NA</div>

                </div>
            ); 
        }

        return (
            <div className="x_content">
                <div>Device ID: husqvarna1</div>

                <div>soilHumidity value: {status.sensorData?.attributes?.soilHumidity?.value}</div>
                <div>soilHumidity timestamp: {status.sensorData?.attributes?.soilHumidity?.timestamp}</div>
                
                <div>soilTemperature value: {status.sensorData?.attributes?.soilTemperature?.value}</div>
                <div>soilTemperature timestamp: {status.sensorData?.attributes?.soilTemperature?.timestamp}</div>
                            
                <div>ambientTemperature value: {status.sensorData?.attributes?.ambientTemperature?.value}</div>
                <div>ambientTemperature timestamp: {status.sensorData?.attributes?.ambientTemperature?.timestamp}</div>
                
                <div>lightIntensity value: {status.sensorData?.attributes?.lightIntensity?.value}</div>
                <div>lightIntensity timestamp: {status.sensorData?.attributes?.lightIntensity?.timestamp}</div>

                <div>batteryLevel value: {status.sensorData?.attributes?.batteryLevel?.value}</div>
                <div>batteryLevel timestamp: {status.sensorData?.attributes?.batteryLevel?.timestamp}</div>

                <div>batteryState value: {status.sensorData?.attributes?.batteryState?.value}</div>
                <div>batteryState timestamp: {status.sensorData?.attributes?.batteryState?.timestamp}</div>

                <div>rfLinkLevel value: {status.sensorData?.attributes?.rfLinkLevel?.value}</div>
                <div>rfLinkLevel timestamp: {status.sensorData?.attributes?.rfLinkLevel?.timestamp}</div>

                <div>waterValve value: {status.valveData?.attributes?.activity?.value}</div>
                <div>waterValve status: {status.valveData?.attributes?.state?.value}</div>

            </div>
        );
    };

    return (
        <div className="right_col" role="main">
			<header className="page-heading device-page-heading">
				<div>
					<p className="eyebrow">CONNECTED DEVICE</p>
					<h1>Husqvarna</h1>
				</div>
			</header>

            <div className="page-title">
				<div className="row top_tiles">
					<div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
						<div className="tile-stats">
							<h3>Soil Humidity</h3>                            
							{renderSoilHumidity()}
                            <div className="icon"><FontAwesomeIcon icon={faDroplet} size="3x" /></div>
						</div>
					</div>


					<div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
						<div className="tile-stats">
							<h3>Soil Temperature</h3>
							{renderSoilTemperature()}
                            <div className="icon"><FontAwesomeIcon icon={faThermometer} size="3x" /></div>
						</div>
					</div>


					<div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
						<div className="tile-stats">
							<h3>Ambient Temperature</h3>
							{renderAmbientTemperature()}
                            <div className="icon"><FontAwesomeIcon icon={faThermometerHalf} size="3x" /></div>
						</div>
					</div>

					<div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
						<div className="tile-stats">
							<h3>Light Intensity</h3>
							{renderLightIntensity()}
                            <div className="icon"><FontAwesomeIcon icon={faSun} size="3x" /></div>
						</div>
					</div>

                    <div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
						<div className="tile-stats">
							<h3>Water Valve</h3>
							{renderWaterValve()}                            
						</div>
					</div>

                    <div className="animated flipInY col-lg-4 col-md-4 col-sm-12 col-xs-12">
						<div className="tile-stats">
							<h3>Water Valve Status</h3>
							{renderWaterValveStatus()}
                            <div className="icon"><FontAwesomeIcon icon={faTriangleExclamation} size="3x" /></div>                            
						</div>
					</div>

                </div>
            </div>

            <div className="row">
                <div className="col-xs-12">
                    <div className="x_panel">
                        <div className="x_title">
                            <h2>Details</h2>
                            <ul className="nav navbar-right panel_toolbox">
                                <li>
                                    <span id="collapse-link-details" className="collapse-link">
                                        <FontAwesomeIcon icon={faChevronUp} size="lg" />
                                    </span>
                                </li>
                                <li>
                                    <span className="close-link">
                                        <FontAwesomeIcon icon={faClose} size="lg" />
                                    </span>
                                </li>
                            </ul>
                            <div className="clearfix"></div>
                        </div>

                        {renderDetails()}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Husqvarna;
